<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="(product, index) in products"
      :key="index"
      class="product__thumb"
      :class="{'product__thumb--selected': isSelected(product)}"
      @click.stop.prevent="select(product)"
    >
      <img
        class="product__thumb__img"
        :src="getThumb(product)"
        alt=""
      >
      <div
        v-if="isSelected(product)"
        class="product__thumb__icon"
      >
        <font-awesome-icon icon="check" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ProductSelectorSuggested',
  data() {
    return {
      selected: [],
    };
  },
  computed: {
    ...mapState({
      products: (state) => state.products.items,
    }),
  },
  watch: {
    selected() {
      this.$emit('select', this.selected);
    },
  },
  mounted() {
    this.selected = [];
    this.fetchData();
  },
  methods: {
    ...mapActions('products', ['fetchData']),
    getThumb(item) {
      return item.image_url;
    },
    isSelected(item) {
      const index = this.selected.indexOf(item);

      if (index === -1) {
        return false;
      }
      return true;
    },
    select(item) {
      const index = this.selected.indexOf(item);

      if (index === -1) {
        this.selected.push(item);
      } else {
        this.selected.splice(index, 1);
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    complete() {
      this.$emit('complete', this.selected);
    },
  },
};
</script>
